/**
 * The one switch for the "Sprawdź swój plan" CTA (JDG conversion design 2026-10-27, slices 2-3).
 *
 * `null` while the `/start` funnel is not live in production: every caller then falls back to
 * its own app's JDG sign-up link (`buildAppSignupUrl` in apps/frontend, `buildSignUpUrl` in
 * apps/landing), which already carry attribution. Slice 3 sets the URL here once and every CTA
 * on both apps moves to `/start` together.
 */
export const START_FUNNEL_URL: string | null = null;

/** The `/start` URL tagged with `signup_source`, or `null` while `/start` is not live. */
export function startFunnelHref(source: string): string | null {
  if (!START_FUNNEL_URL) return null;
  const url = new URL(START_FUNNEL_URL);
  url.searchParams.set('signup_source', source);
  return url.toString();
}
